import '.ai{flex-shrink:0;}.ssr-plugin'
import '.ac{padding:1rem;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.al{height:100%;}.ssr-plugin'
import '.bg{border:none;}.ssr-plugin'
import '.ck{background-color:transparent;}.ssr-plugin'
import '.cl{border-radius:0px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.a8{align-items:stretch;}.ssr-plugin'
import '.c1{position:sticky;}.ssr-plugin'
import '.cm{top:4rem;}.ssr-plugin'
import '.cn{z-index:7;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.co{padding-bottom:1rem;}.ssr-plugin'
import '.cp{margin-bottom:1rem;}.ssr-plugin'
import '.cq{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.i{position:fixed;}.ssr-plugin'
import '.bm{top:0px;}.ssr-plugin'
import '.bn{left:0px;}.ssr-plugin'
import '.bo{right:0px;}.ssr-plugin'
import '.bp{bottom:0px;}.ssr-plugin'
import '.cr{z-index:9999;}.ssr-plugin'
import '.cs{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.c0{justify-content:flex-end;}.ssr-plugin'
import '.am{flex:1;}.ssr-plugin'
import '.by{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { TextLink } from '@app/components/core/link/TextLink'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="ai ac l al bg ck cl"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="d e a8"
    >
      <div className="c1 cm cn t co cp cq d"
      >
        <TextLink onClick={() => setIsOpen(true)}>{collapsedButtonLabel}</TextLink>
      </div>

      <div className="i bm bn bo bp cr t cs d e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="ac d c0 cq"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="am by">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
